export default function HeroSection() {
  const scrollToCategories = () => {
    const el = document.getElementById('categories-section');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-[90vh] min-h-[600px] mt-16 md:mt-[4.5rem] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20composition%20with%20white%20sneakers%20beige%20hoodie%20leather%20watch%20and%20canvas%20tote%20bag%20arranged%20on%20natural%20linen%20fabric%2C%20warm%20sunlight%20from%20large%20window%2C%20minimalist%20cream%20and%20sand%20color%20palette%2C%20editorial%20fashion%20photography%20with%20organic%20textures%20and%20plenty%20of%20negative%20space%2C%20soft%20diffused%20shadows&width=1800&height=1200&seq=hero-main-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet curated fashion collection with sneakers hoodie watch and accessories"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6">
        {/* Pill Badge */}
        <div className="inline-flex items-center gap-2 border border-background-50/30 rounded-full px-4 py-1.5 mb-6 backdrop-blur-sm">
          <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
          <span className="text-xs md:text-sm text-background-50/90 font-medium tracking-wide uppercase">
            Updated June 2026
          </span>
        </div>

        {/* Main Title */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold text-background-50 leading-tight max-w-4xl">
          Best Sugargoo Spreadsheet
          <br />
          <span className="font-heading italic font-normal">Discover Verified Finds 2026</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-5 text-sm md:text-lg text-background-50/80 font-light max-w-2xl leading-relaxed">
          Explore the most comprehensive Sugargoo spreadsheet with verified product links across sneakers,
          hoodies, jackets, bags, watches, and accessories. Updated daily with trusted seller finds.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            View Full Spreadsheet
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <button
            onClick={scrollToCategories}
            className="inline-flex items-center gap-2 border border-background-50/40 text-background-50 px-7 py-3.5 rounded-full text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-all cursor-pointer backdrop-blur-sm"
          >
            Browse Categories
            <i className="ri-arrow-down-line text-lg"></i>
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}